import { render } from "./WhatsAppAccountsView.vue?vue&type=template&id=384c721d&scoped=true"
import script from "./WhatsAppAccountsView.vue?vue&type=script&lang=js"
export * from "./WhatsAppAccountsView.vue?vue&type=script&lang=js"

import "./WhatsAppAccountsView.vue?vue&type=style&index=0&id=384c721d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384c721d"]])

export default __exports__